class Axeptio {
    constructor(options = {}){
        this.options = Object.assign(
            {},
            {     
                clientId: "60bf2ef0738e6c4469f39d81",
                cookiesVersion: "novexpert-lab-fr-EU"
            }, 
            options 
        );   

        window.consentModeV2 = "";
        window.axeptioCookies = "";

        window.dataLayer = window.dataLayer || []; 
        window.gtag = function(){dataLayer.push(arguments)}; 

        window.gtag('consent', 'default', {
            analytics_storage: 'denied',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied', 
            wait_for_update: 500  
        }); 

        window.axeptioSettings = {
            clientId: this.options.clientId,
            cookiesVersion: this.options.cookiesVersion,
            googleConsentMode: {
                default: {
                    analytics_storage: 'denied',
                    ad_storage: 'denied',
                    ad_user_data: 'denied', 
                    ad_personalization: 'denied',
                    wait_for_update: 500 
                } 
            }
        }; 
 
        
        if(!this.checkoutState){
            window.Shopify.loadFeatures([
                {
                name: "consent-tracking-api",
                version: "0.1",
                },
            ], () => {
                this.init();
            }); 
        }  
         
    } 
 
    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }  
    
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    
    setCookie(name,value,days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }   

    init() {  

        console.log("init");
 
        //Chargement script Axeptio   
        var t = document.getElementsByTagName("script")[0], e = document.createElement("script");
        e.async = true; e.src = "//static.axept.io/sdk.js";
        t.parentNode.insertBefore(e, t);

        //Check du save
        void 0 === window._axcb && (window._axcb = []);
        //https://developers.google.com/tag-platform/security/guides/consent?hl=fr&consentmode=advanced 

        //Test des cookies axeptio 
        if(this.getCookie("axeptio_cookies") != null){ 
            window.axeptioCookies = JSON.parse(decodeURIComponent(this.getCookie("axeptio_cookies"))).$$googleConsentMode; 
        } 

        //Mise à jour consentement
        window._axcb.push((axeptio) => {  
            if(axeptio.userPreferencesManager.choices.$$completed){
                if(document.querySelector("#axeptio_overlay") != null){
                    document.querySelector("#axeptio_overlay").style.display = "none";  
                }
                window.consentModeV2 = axeptio.userPreferencesManager.choices.$$googleConsentMode;  
            } 
            axeptio.on("consent:saved", function(rep) {  
                if(document.querySelector("#axeptio_overlay") != null){
                    document.querySelector("#axeptio_overlay").style.display = "none";   
                }  
            });
            window.gtag('consent', 'update', { 
                'ad_storage': window.axeptioCookies.ad_storage,
                'ad_user_data': window.axeptioCookies.ad_user_data,
                'ad_personalization': window.axeptioCookies.ad_personalization,
                'analytics_storage': window.axeptioCookies.analytics_storage
            });
        });  
 
        window.Shopify.customerPrivacy.setTrackingConsent(
            {
                preferences: true,
                analytics: true,
                marketing: true,
                sale_of_data: true
            }, 
            () => {}
        );  
 
    }  
}

const axeptio = new Axeptio();